export default {
  objective: 'Objective',
  keyResult: 'Key Result',
  startDay: 'Start Date',
  finishDay: 'Deadline',
  indicator: 'Indicators',
  weight: 'Weight',
  proportion: 'Weight',
  progress: 'Progress',
  align: 'Align',
  state: 'State',
  ok: 'OK',
  cancel: 'Cancel',
  delete: 'Delete',
  reset: 'Reset',
  createDialog: {
    ok: 'Create',
    cancelWarning: 'The Editing Content will not be saved, confirm to exit？'
  },
  editDialog: {
    ok: 'Save',
    cancelWarning: 'The Editing Content will not be saved, confirm to exit？'
  },
  deleteDialog: {
    ok: 'Confirm'
  },
  searchInputPlaceHolder: 'Please input nickname or name to search user',
  frequentContacts: 'Frequent Contacts',
  noData: 'No Data',
  noPermission: 'No permission to view',
  backToOld: 'Back to old version'
}
